import React from 'react';
import Loader from '../Loader/Loader'; // Import the existing Loader component
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = () => (
  <div className={styles.loaderContainer}>
    <div className={styles.loader}>
      <Loader /> {/* Use the shifting ellipsis loader */}
    </div>
    <p className={styles.loaderText}>Submitting data, please do not close the page...</p>
  </div>
);

export default LoadingOverlay;